module.exports = __webpack_public_path__ + "img/C Plus Plus.f278be79.png";